<app-card-header-loader *ngIf="isLoading | async; else detailView" />

<ng-template #detailView>
  <app-card [cardClasses]="'mb-8'">
    <ng-container cardBody>
      <ng-container [ngTemplateOutlet]="cardTitleTpl" />
      <ng-container *ngIf="headerConfig?.useSection; else withDetailTpl" [ngTemplateOutlet]="useSectionTpl"></ng-container>
    </ng-container>
  </app-card>

  <ng-template #cardTitleTpl>
    <div class="card-title mb-8">
      <div class="d-flex align-items-center mb-3">
        <h2 class="mb-0 me-4">{{ title }}</h2>
        <div *ngIf="headerConfig?.useStatusBadge" [innerHTML]="renderStatusBadge()"></div>
      </div>
    </div>
  </ng-template>

  <ng-template #withDetailTpl>
    <ng-container *ngIf="dataSubject | async as detail">
      <app-text-copy-clipboard
        *ngIf="hasErpCode() && showCopyClipboard()"
        [popoverText]="'Id ERP berhasil di copy'"
        [text]="getCopyClipboardText()"
        [valueToCopy]="getCopyClipboardValue()"
      />

      <app-text-copy-clipboard *ngIf="hasTagCode()" [popoverText]="'Tag code berhasil di copy'" [text]="getCopyClipboardText(true)" [valueToCopy]="getCopyClipboardValue(true)" />

      <!-- area - warehouse info -->
      <div class="me-4" *ngIf="detail['is_tag']">Cabang: {{ detail['warehouse_name'] }}</div>
      <div class="me-4" *ngIf="detail['warehouse_name'] && detail['warehouse_address']">Gudang Pengirim: {{ detail['warehouse_name'] + ', ' + detail['warehouse_address'] }}</div>

      <!-- noteview info for pending spm -->
      <div class="mt-6" *ngIf="detail['status_enum'] === StatusSPM.PENDING">
        <app-note-view [color]="'info'" [text]="getNoteviewText()" [icon]="STRING_CONSTANTS.ICON.IC_INFORMATION" />
      </div>

      <hr />

      <div class="d-flex w-100 gap-3" *ngIf="!!detailChanges.length">
        <div [class]="detailChanges.length <= 4 ? (detailChanges.length === 3 ? 'w-33' : 'w-25') : 'w-20'" *ngFor="let item of detailChanges">
          <div class="font-12 fw-semibold text-gray-500 mb-2">{{ item.title }}</div>
          <p *ngIf="item.actor" class="mb-0 font-14 fw-bold text-gray-800">{{ item.actor }}</p>
          <p class="font-14 fw-bold text-gray-800">
            {{ generateDate(item.date) }}
          </p>

          <ng-container *ngIf="item.document">
            <app-image
              [ctaLabelClass]="'fw-bold text-info cursor-pointer'"
              [ctaLabel]="'Lihat Dokumen Approval'"
              [modalOptions]="{ size: 'md' }"
              [src]="item.document"
              [useImagePreview]="false"
            />
          </ng-container>
        </div>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #useSectionTpl>
    <div *ngIf="dataSection && !!dataSection.length" class="row align-items-start">
      <div class="col-12 col-md" *ngFor="let item of dataSection">
        <div class="font-12 fw-semibold text-gray-500 mb-2">{{ item.title }}</div>
        <div class="fw-bold text-gray-800">{{ item.value }}</div>
        <div class="fw-bold text-gray-800">{{ item.description }}</div>
      </div>
    </div>
  </ng-template>
</ng-template>
